"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactTracking = require("react-tracking");

var _Button = _interopRequireDefault(require("../../elements/button/Button"));

var _Link = _interopRequireDefault(require("../../elements/link/Link"));

var _stitches = require("../../stitches.config");

var _wizardsSlice = require("../../store/wizardsSlice");

var _DetailedImageQuestion = _interopRequireDefault(require("./detailed-image-question/DetailedImageQuestion"));

var _ImageChangingQuestion = _interopRequireDefault(require("./image-changing-question/ImageChangingQuestion"));

var _ImageOrLottie = _interopRequireDefault(require("./image-or-lottie/ImageOrLottie"));

var _ImageQuestion = _interopRequireDefault(require("./image-question/ImageQuestion"));

var _Loading = _interopRequireDefault(require("./loading/Loading"));

var _MoreInformation = _interopRequireDefault(require("./more-information/MoreInformation"));

var _Section = _interopRequireDefault(require("./section/Section"));

var _SizeWidthQuestion = _interopRequireDefault(require("./size-width-question/SizeWidthQuestion"));

var StyledWizard = (0, _stitches.styled)('div', {
  color: '$textPrimary',
  display: 'flex',
  flex: '1',
  flexDirection: 'column',
  fontFamily: '$asics',
  // asics3.0 override
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '1024px',
  paddingLeft: '30px',
  paddingRight: '30px',
  overflowX: 'hidden',
  a: {
    fontSize: '15px',
    // unset sfcc styles
    overflow: 'unset'
  },
  button: {
    // asics3.0 override
    fontFamily: '$asics',
    fontSize: '15px',
    fontWeight: '$bold',
    letterSpacing: '0.4px',
    // unset sfcc styles
    backgroundColor: '$primary',
    borderColor: 'unset',
    border: 0,
    display: 'block',
    lineHeight: 'normal',
    padding: '16px 15px',
    textTransform: 'unset',
    transition: 'none',
    '&:hover:not([disabled])': {
      backgroundColor: '$primaryHover',
      border: 0,
      outline: 0
    },
    '&:focus': {
      outline: '2px solid #001e63',
      backgroundColor: '$primaryHover'
    }
  },
  // unset sfcc styles
  li: {
    fontFamily: 'unset',
    fontSize: 'unset',
    fontWeight: 'unset',
    lineHeight: 'unset'
  },
  // unset sfcc styles
  p: {
    fontFamily: 'unset',
    fontSize: 'unset',
    fontWeight: 'unset',
    lineHeight: 'unset',
    a: {
      fontFamily: 'unset',
      fontSize: 'unset',
      fontWeight: 'unset',
      lineHeight: 'unset'
    }
  }
});
var WizardBanner = (0, _stitches.styled)('div', {
  alignItems: 'center',
  background: '$secondaryLightIndigo',
  display: 'flex',
  height: '40px',
  justifyContent: 'center',
  left: 0,
  position: 'absolute',
  width: '100vw',
  div: {
    fontWeight: '$bold'
  }
});
var BackGroupWidthDefiner = (0, _stitches.styled)('div', {
  alignItems: 'center',
  display: 'flex',
  margin: 'auto',
  position: 'absolute',
  width: '90%',
  '@desktop': {
    width: '1024px'
  }
});
var BackGroup = (0, _stitches.styled)('div', {
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  userSelect: 'none',
  img: {
    height: '30px',
    width: '30px'
  },
  span: {
    display: 'none'
  },
  '&:hover': {
    cursor: 'pointer'
  },
  '@desktop': {
    span: {
      display: 'inline',
      marginLeft: '5px'
    }
  }
});
var SkipGroup = (0, _stitches.styled)('div', {
  fontWeight: '$bold',
  '&:hover': {
    cursor: 'pointer'
  }
});
var ProgressBar = (0, _stitches.styled)('div', {
  alignItems: 'center',
  background: '$secondary',
  borderTopRightRadius: '25px',
  borderBottomRightRadius: '25px',
  color: '$white',
  display: 'flex',
  fontSize: '$xSmall',
  fontWeight: '$medium',
  height: '12px',
  justifyContent: 'flex-end',
  left: 0,
  position: 'absolute',
  top: '40px',
  transition: 'width 1s ease-in-out'
});
var WizardBody = (0, _stitches.styled)('div', {
  display: 'flex',
  flexDirection: 'column',
  marginTop: '70px',
  width: '100%'
});
var slideRightToLeft = (0, _stitches.keyframes)({
  '0%': {
    transform: 'translateX(100%)'
  },
  '100%': {
    transform: 'translateX(0%)'
  }
});
var slideLeftToRight = (0, _stitches.keyframes)({
  '0%': {
    transform: 'translateX(-100%)'
  },
  '100%': {
    transform: 'translateX(0%)'
  }
});
var WizardTitleWrapper = (0, _stitches.styled)('div', {
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '300px',
  overflowWrap: 'break-word'
});
var WizardTitle = (0, _stitches.styled)('h1', {
  textAlign: 'center',
  // unset sfcc styles
  fontSize: '$xxxLarge',
  lineHeight: 'unset'
});
var NavButtonContainer = (0, _stitches.styled)('div', {
  display: 'flex',
  flexDirection: 'column',
  marginTop: '15px',
  marginLeft: 'auto',
  marginRight: 'auto',
  textAlign: 'center',
  width: '50%',
  button: {
    flex: '1',
    marginBottom: '15px'
  },
  '@tablet': {
    width: '33%'
  }
});
var DisclaimerWrapper = (0, _stitches.styled)('div', {
  color: '#6a6a6a',
  // wooo
  fontSize: '13px',
  // not using a token cause we don't like consistency
  overflowWrap: 'break-word',
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '350px',
  flex: '1',
  a: {
    fontSize: '13px',
    textDecoration: 'underline',
    margin: 0,
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  // '@tablet': {
  //   a: {
  //     textDecoration: 'none',
  //     '&:hover': {
  //       textDecoration: 'underline',
  //     },
  //   },
  // },
  variants: {
    text: {
      left: {
        textAlign: 'left'
      },
      center: {
        textAlign: 'center'
      }
    }
  }
});
var WizardChildComponents = {
  DetailedImageQuestion: _DetailedImageQuestion.default,
  ImageChangingQuestion: _ImageChangingQuestion.default,
  ImageCheckboxQuestion: _ImageQuestion.default,
  SectionStep: _Section.default,
  SizeWidthQuestion: _SizeWidthQuestion.default
};
/**
 * A guided experience that triggers some action at the end. Uses Contentful for wizard content.
 */

var Wizard = function Wizard(_ref) {
  var _wizard$stepsCollecti, _wizard$title, _wizard$stepsCollecti2, _wizard$stepsCollecti3, _wizard$stepsCollecti4, _wizard$stepsCollecti5, _wizard$stepsCollecti6, _wizard$stepsCollecti7, _wizard$stepsCollecti8, _wizard$stepsCollecti9, _wizard$stepsCollecti10, _wizard$stepsCollecti11, _wizard$stepsCollecti12, _wizard$stepsCollecti13, _wizard$stepsCollecti14, _wizard$stepsCollecti15, _wizard$stepsCollecti16, _wizard$stepsCollecti17, _wizard$stepsCollecti18, _wizard$stepsCollecti26, _wizard$stepsCollecti27, _currentStep$__typena, _wizard$stepsCollecti31, _wizard$stepsCollecti32, _wizard$stepsCollecti33, _wizard$backArrow, _wizard$logo, _wizard$logo2, _wizard$stepsCollecti34, _wizard$stepsCollecti35, _currentStep$moreInfo, _currentStep$moreInfo2, _wizard$stepsCollecti36, _wizard$stepsCollecti37, _wizard$disclaimerTex, _wizard$submitDisclai, _wizard$submitDisclai2, _wizard$submitDisclai3, _wizard$title2, _wizard$stepsCollecti38, _wizard$disclaimerTex2, _wizard$disclaimer, _wizard$disclaimer$js, _wizard$disclaimer$js2;

  var contentfulApi = _ref.contentfulApi,
      id = _ref.id,
      locale = _ref.locale,
      previewFlag = _ref.previewFlag,
      noFetch = _ref.noFetch,
      onSubmit = _ref.onSubmit;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.wizards;
  }),
      questions = _useSelector.questions,
      steps = _useSelector.steps,
      wizards = _useSelector.wizards;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      currentStepIndex = _useState2[0],
      setCurrentStepIndex = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      clickDirection = _useState4[0],
      setClickDirection = _useState4[1]; // right = 0, left = 1


  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      clickIncrementer = _useState6[0],
      incrementClick = _useState6[1]; // used to rerender wizard body to retrigger animations


  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      started = _useState8[0],
      setStarted = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      showLoading = _useState10[0],
      setShowLoading = _useState10[1];

  var _useState11 = (0, _react.useState)(0),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      pollingInterval = _useState12[0],
      setPollingInterval = _useState12[1];

  var _useTracking = (0, _reactTracking.useTracking)(),
      Track = _useTracking.Track,
      trackEvent = _useTracking.trackEvent;

  var handleTracking = function handleTracking(gaEventAction, gaEventLabel, gaEventNonInteraction, sf2_question_number, sf2_section_label, sf2_section_number) {
    trackEvent({
      gaEventAction: gaEventAction,
      gaEventLabel: gaEventLabel,
      gaEventNonInteraction: gaEventNonInteraction,
      sf2_question_number: sf2_question_number,
      sf2_section_label: sf2_section_label,
      sf2_section_number: sf2_section_number
    });
  };

  var wizard = wizards === null || wizards === void 0 ? void 0 : wizards[id];
  var quizPercentage = started ? "".concat(Math.floor(100 * (currentStepIndex + 1) / (wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti = wizard.stepsCollection) === null || _wizard$stepsCollecti === void 0 ? void 0 : _wizard$stepsCollecti.items.length)), "%") : '0%';
  var getQuestionTitle = wizard === null || wizard === void 0 ? void 0 : (_wizard$title = wizard.title) === null || _wizard$title === void 0 ? void 0 : _wizard$title.replace('#', wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti2 = wizard.stepsCollection) === null || _wizard$stepsCollecti2 === void 0 ? void 0 : _wizard$stepsCollecti2.items.filter(function (step) {
    return step.__typename !== 'SectionStep';
  }).length);
  var currentStep = (questions === null || questions === void 0 ? void 0 : questions[wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti3 = wizard.stepsCollection) === null || _wizard$stepsCollecti3 === void 0 ? void 0 : (_wizard$stepsCollecti4 = _wizard$stepsCollecti3.items) === null || _wizard$stepsCollecti4 === void 0 ? void 0 : (_wizard$stepsCollecti5 = _wizard$stepsCollecti4[currentStepIndex]) === null || _wizard$stepsCollecti5 === void 0 ? void 0 : (_wizard$stepsCollecti6 = _wizard$stepsCollecti5.sys) === null || _wizard$stepsCollecti6 === void 0 ? void 0 : _wizard$stepsCollecti6.id]) || (steps === null || steps === void 0 ? void 0 : steps[wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti7 = wizard.stepsCollection) === null || _wizard$stepsCollecti7 === void 0 ? void 0 : (_wizard$stepsCollecti8 = _wizard$stepsCollecti7.items) === null || _wizard$stepsCollecti8 === void 0 ? void 0 : (_wizard$stepsCollecti9 = _wizard$stepsCollecti8[currentStepIndex]) === null || _wizard$stepsCollecti9 === void 0 ? void 0 : (_wizard$stepsCollecti10 = _wizard$stepsCollecti9.sys) === null || _wizard$stepsCollecti10 === void 0 ? void 0 : _wizard$stepsCollecti10.id]);
  var nextStep = (questions === null || questions === void 0 ? void 0 : questions[wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti11 = wizard.stepsCollection) === null || _wizard$stepsCollecti11 === void 0 ? void 0 : (_wizard$stepsCollecti12 = _wizard$stepsCollecti11.items) === null || _wizard$stepsCollecti12 === void 0 ? void 0 : (_wizard$stepsCollecti13 = _wizard$stepsCollecti12[currentStepIndex + 1]) === null || _wizard$stepsCollecti13 === void 0 ? void 0 : (_wizard$stepsCollecti14 = _wizard$stepsCollecti13.sys) === null || _wizard$stepsCollecti14 === void 0 ? void 0 : _wizard$stepsCollecti14.id]) || (steps === null || steps === void 0 ? void 0 : steps[wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti15 = wizard.stepsCollection) === null || _wizard$stepsCollecti15 === void 0 ? void 0 : (_wizard$stepsCollecti16 = _wizard$stepsCollecti15.items) === null || _wizard$stepsCollecti16 === void 0 ? void 0 : (_wizard$stepsCollecti17 = _wizard$stepsCollecti16[currentStepIndex + 1]) === null || _wizard$stepsCollecti17 === void 0 ? void 0 : (_wizard$stepsCollecti18 = _wizard$stepsCollecti17.sys) === null || _wizard$stepsCollecti18 === void 0 ? void 0 : _wizard$stepsCollecti18.id]);
  var wizardQueryData = {
    wizardId: id,
    locale: locale,
    previewFlag: previewFlag
  };
  (0, _react.useEffect)(function () {
    if (previewFlag) {
      setPollingInterval(500);
    } else {
      setPollingInterval(0);
    }
  }, [pollingInterval]);

  var _contentfulApi$useGet = contentfulApi.useGetWizardQuery(wizardQueryData, {
    pollingInterval: pollingInterval
  }),
      wizardData = _contentfulApi$useGet.data;

  (0, _react.useEffect)(function () {
    var _wizardData$data;

    var data = wizardData === null || wizardData === void 0 ? void 0 : (_wizardData$data = wizardData.data) === null || _wizardData$data === void 0 ? void 0 : _wizardData$data.wizard;

    if (data && !noFetch) {
      dispatch((0, _wizardsSlice.setWizardData)(data));
    }

    if (data && noFetch) {
      setStarted(true);
      incrementClick(0);
    }
  }, [dispatch, incrementClick, noFetch, setStarted, wizardData]);
  (0, _react.useEffect)(function () {
    var scrollToView = function scrollToView() {
      if (document.getElementById('primary') !== null) {
        document.getElementById('primary').scrollIntoView();
      }
    };

    document.addEventListener('DOMContentLoaded', scrollToView); // Remove the event listener when component unmounts

    return function () {
      return document.removeEventListener('DOMContentLoaded', scrollToView);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var gaEventAction = "question | start | ".concat(quizPercentage);
    var gaEventLabel = "".concat(currentStepIndex, " | ").concat(getQuestionTitle);
    handleTracking(gaEventAction, gaEventLabel, true, 1, 'start', 1);
  }, []);

  var startWizard = function startWizard(btn_txt) {
    setStarted(true);
    setClickDirection(0);
    incrementClick(clickIncrementer + 1);
    var gaEventAction = "response | start | ".concat(quizPercentage);
    var gaEventLabel = "0 | ".concat(btn_txt);
    handleTracking(gaEventAction, gaEventLabel, false, 1, 'start', 1);
  };

  var restartWizard = function restartWizard() {
    return setStarted(false);
  }; // TODO: analytics


  var nextQuestion = function nextQuestion() {
    var _wizard$stepsCollecti19, _wizard$stepsCollecti20;

    // TODO: analytics
    if (currentStepIndex === (wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti19 = wizard.stepsCollection) === null || _wizard$stepsCollecti19 === void 0 ? void 0 : (_wizard$stepsCollecti20 = _wizard$stepsCollecti19.items) === null || _wizard$stepsCollecti20 === void 0 ? void 0 : _wizard$stepsCollecti20.length) - 1) {// noop currently. could do something cool here.
    } else {
      setCurrentStepIndex(currentStepIndex + 1);
      setClickDirection(0);
      incrementClick(clickIncrementer + 1);
    }
  };

  var contine_btns = function contine_btns(currentStep) {
    var _wizard$stepsCollecti21;

    var wizardItems = wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti21 = wizard.stepsCollection) === null || _wizard$stepsCollecti21 === void 0 ? void 0 : _wizard$stepsCollecti21.items;
    var wizardIndex = wizardItems.findIndex(function (wiz) {
      return wiz.title === currentStep.title;
    }) + 1;

    if (currentStep.__typename == 'SectionStep') {
      var gaEventAction = "response | ".concat(currentStep.category, " | ").concat(quizPercentage);
      var gaEventLabel = "".concat(wizardIndex, " | ").concat(currentStep.nextButtonText);
      handleTracking(gaEventAction, gaEventLabel, false, '', currentStep.category, wizardIndex);
    }

    if (currentStep.__typename == 'SizeWidthQuestion') {
      var _currentStep$sizeQues, _currentStep$sizeQues2, _currentStep$widthQue;

      var _gaEventAction = "response | ".concat(currentStep.category, " | ").concat(quizPercentage);

      var _gaEventLabel = "".concat(wizardIndex, " | ").concat(currentStep.genderQuestion.answer, " | ").concat((_currentStep$sizeQues = currentStep.sizeQuestion) === null || _currentStep$sizeQues === void 0 ? void 0 : (_currentStep$sizeQues2 = _currentStep$sizeQues.answers) === null || _currentStep$sizeQues2 === void 0 ? void 0 : _currentStep$sizeQues2.toString(), " | ").concat(currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$widthQue = currentStep.widthQuestion) === null || _currentStep$widthQue === void 0 ? void 0 : _currentStep$widthQue.answer);

      handleTracking(_gaEventAction, _gaEventLabel, false, 3, currentStep.category, wizardIndex);
    }

    if (currentStep.__typename == 'ImageChangingQuestion' || currentStep.__typename == 'DetailedImageQuestion') {
      var _currentStep$choices;

      var _gaEventAction2 = "response | ".concat(currentStep.category, " | ").concat(quizPercentage);

      var answer = currentStep === null || currentStep === void 0 ? void 0 : currentStep.answer;
      answer = currentStep.answers.length > 0 ? currentStep.answers.toString() : answer;
      handleTracking(_gaEventAction2, answer, false, currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$choices = currentStep.choices) === null || _currentStep$choices === void 0 ? void 0 : _currentStep$choices.length, currentStep.category, wizardIndex);
    }

    if (currentStep.__typename == 'ImageCheckboxQuestion') {
      var _currentStep$choices2;

      var _gaEventAction3 = "response | ".concat(currentStep.category, " | ").concat(quizPercentage);

      var _answer = "".concat(wizardIndex, " | ").concat(currentStep.answers.length > 0 ? currentStep.answers.toString() : currentStep.answer);

      handleTracking(_gaEventAction3, _answer, false, currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$choices2 = currentStep.choices) === null || _currentStep$choices2 === void 0 ? void 0 : _currentStep$choices2.length, currentStep.category, wizardIndex);
    }
  }; // this is used for sfcc, it will scroll the app to the 
  // primary div element that is in sfcc


  var pageAnchor = function pageAnchor() {
    if (document.getElementById('primary') !== null) {
      document.getElementById('primary').scrollIntoView();
    }

    ;
  };

  var questionTracking = function questionTracking(thisStep) {
    var _wizard$stepsCollecti22, _wizard$stepsCollecti23;

    var wizardItems = wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti22 = wizard.stepsCollection) === null || _wizard$stepsCollecti22 === void 0 ? void 0 : _wizard$stepsCollecti22.items;
    var wizardIndex = wizardItems.findIndex(function (wiz) {
      return wiz.title === thisStep.title;
    }) + 1;
    pageAnchor();
    var gaEventAction = "question | ".concat(thisStep.category, " | ", "".concat(Math.floor(100 * wizardIndex / (wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti23 = wizard.stepsCollection) === null || _wizard$stepsCollecti23 === void 0 ? void 0 : _wizard$stepsCollecti23.items.length)), "%"));
    var gaEventLabel = "".concat(wizardIndex, " | ").concat(thisStep.title);
    handleTracking(gaEventAction, gaEventLabel, false, thisStep.choices, category, wizardIndex);
  };

  var skipTracking = function skipTracking(thisStep) {
    var _wizard$stepsCollecti24, _wizard$stepsCollecti25;

    var wizardItems = wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti24 = wizard.stepsCollection) === null || _wizard$stepsCollecti24 === void 0 ? void 0 : _wizard$stepsCollecti24.items;
    var wizardIndex = wizardItems.findIndex(function (wiz) {
      return wiz.title === thisStep.title;
    }) + 1;
    var gaEventAction = "skip | ".concat("".concat(Math.floor(100 * wizardIndex / (wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti25 = wizard.stepsCollection) === null || _wizard$stepsCollecti25 === void 0 ? void 0 : _wizard$stepsCollecti25.items.length)), "%"));
    var gaEventLabel = "".concat(wizardIndex, " | ").concat(thisStep.title);
    handleTracking(gaEventAction, gaEventLabel, false, thisStep.choices, category, wizardIndex);
  };

  var previousQuestion = function previousQuestion() {
    // TODO: analytics
    if (currentStepIndex === 0) {
      restartWizard();
    } else {
      setCurrentStepIndex(currentStepIndex - 1);
    }

    setClickDirection(1);
    incrementClick(clickIncrementer + 1);
  };

  var renderedQuestions = wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti26 = wizard.stepsCollection) === null || _wizard$stepsCollecti26 === void 0 ? void 0 : (_wizard$stepsCollecti27 = _wizard$stepsCollecti26.items) === null || _wizard$stepsCollecti27 === void 0 ? void 0 : _wizard$stepsCollecti27.map(function (step) {
    var _wizard$stepsCollecti28, _wizard$stepsCollecti29;

    // TODO: This doesn't work in pwa-kit, investigate later
    // const componentName = step.type.charAt(0).toUpperCase() + step.type.slice(1);
    // const ChildComponent = lazy(() => import(`./${componentName}/${componentName}`));
    var ChildComponent = WizardChildComponents[step.__typename];
    return /*#__PURE__*/_react.default.createElement(ChildComponent, Object.assign({
      category: category,
      currentStepIndex: currentStepIndex + 1,
      id: step.sys.id,
      key: step.sys.id,
      quizPercentage: quizPercentage,
      totalQuestions: wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti28 = wizard.stepsCollection) === null || _wizard$stepsCollecti28 === void 0 ? void 0 : (_wizard$stepsCollecti29 = _wizard$stepsCollecti28.items) === null || _wizard$stepsCollecti29 === void 0 ? void 0 : _wizard$stepsCollecti29.length,
      onNext: function onNext() {
        questionTracking(nextStep);
        nextQuestion();
      }
    }, step, questions[step.sys.id]));
  });

  var isQuestionAnswered = function isQuestionAnswered() {
    var _currentStep$answers;

    if ((currentStep === null || currentStep === void 0 ? void 0 : currentStep.__typename) === 'SizeWidthQuestion') {
      return Boolean(currentStep.genderQuestion.answer) && currentStep.sizeQuestion.answers.length > 0 && Boolean(currentStep.widthQuestion.answer);
    }

    return currentStep.isSingleSelect ? Boolean(currentStep.answer) : ((_currentStep$answers = currentStep.answers) === null || _currentStep$answers === void 0 ? void 0 : _currentStep$answers.length) > 0;
  };

  var submitWizard = function submitWizard(btnText, currentStep) {
    var _wizard$stepsCollecti30, _currentStep$answers2, _currentStep$answers3, _currentStep$choices3;

    var wizardItems = wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti30 = wizard.stepsCollection) === null || _wizard$stepsCollecti30 === void 0 ? void 0 : _wizard$stepsCollecti30.items;
    var wizardIndex = wizardItems.findIndex(function (wiz) {
      return wiz.title === currentStep.title;
    }) + 1;
    var currentStepAnswer = (currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$answers2 = currentStep.answers) === null || _currentStep$answers2 === void 0 ? void 0 : _currentStep$answers2.toString()) ? currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$answers3 = currentStep.answers) === null || _currentStep$answers3 === void 0 ? void 0 : _currentStep$answers3.toString() : currentStep.answer;
    var currentStepText = currentStepAnswer ? currentStepAnswer : btnText;
    var gaEventAction = "response | ".concat(currentStep.category, " | ").concat(quizPercentage);
    var gaEventLabel = "".concat(wizardIndex, " | ").concat(currentStepText);
    handleTracking(gaEventAction, gaEventLabel, false, currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$choices3 = currentStep.choices) === null || _currentStep$choices3 === void 0 ? void 0 : _currentStep$choices3.length, currentStep.category, wizardIndex);
    gaEventAction = 'results | submit | 100%';
    gaEventLabel = "".concat(wizardIndex, " | ").concat(btnText);
    handleTracking(gaEventAction, gaEventLabel, false, 2, currentStep === null || currentStep === void 0 ? void 0 : currentStep.title, wizardIndex);
    pageAnchor();
    setShowLoading(true);
    onSubmit(id);
  };

  var handleKeyClick = function handleKeyClick(event, type) {
    if (event) {
      if (type === 'link') {
        if (event.key === 'Enter') {
          previousQuestion();
        }
      } else if (type === 'button') {
        if (event.key === ' ' || event.code === 'Space' || event.keyCode === '32' || event.key === 'Enter') {
          previousQuestion();
        }
      }
    }
  };

  var handleSkipClick = function handleSkipClick() {
    skipTracking(currentStep);
    questionTracking(nextStep);
    nextQuestion();
    pageAnchor();
  };

  var handleQuestionSkipClick = function handleQuestionSkipClick(event, type) {
    if (type === 'link' && event.key === 'Enter') {
      handleSkipClick();
    }
  };

  var handleSkipStyleClick = function handleSkipStyleClick(btnText, currentStep) {
    pageAnchor();
    submitWizard(btnText, currentStep);
  };

  var handleSectionSkipClick = function handleSectionSkipClick(event, type, btnText, currentStep) {
    if (type === 'link' && event.key === 'Enter') {
      handleSkipStyleClick(btnText, currentStep);
    }
  };

  var isNextButtonDisabled = (currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$__typena = currentStep.__typename) === null || _currentStep$__typena === void 0 ? void 0 : _currentStep$__typena.includes('Question')) && !isQuestionAnswered();
  var category = started && (currentStep === null || currentStep === void 0 ? void 0 : currentStep.category);
  var progressBarWidth = started ? "".concat(Math.floor(100 * (currentStepIndex + 1) / (wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti31 = wizard.stepsCollection) === null || _wizard$stepsCollecti31 === void 0 ? void 0 : _wizard$stepsCollecti31.items.length))) : '0';
  var progressBarValue = "".concat(progressBarWidth, "%");
  var slideAnimation = 'none';

  if (clickIncrementer > 0) {
    slideAnimation = clickDirection === 0 ? "".concat(slideRightToLeft, " 1000ms") : "".concat(slideLeftToRight, " 1000ms");
  }

  var shouldShowNextButton = (currentStep === null || currentStep === void 0 ? void 0 : currentStep.nextButtonText) && currentStepIndex < (wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti32 = wizard.stepsCollection) === null || _wizard$stepsCollecti32 === void 0 ? void 0 : (_wizard$stepsCollecti33 = _wizard$stepsCollecti32.items) === null || _wizard$stepsCollecti33 === void 0 ? void 0 : _wizard$stepsCollecti33.length) - 1;

  var nextButton = (currentStep === null || currentStep === void 0 ? void 0 : currentStep.nextButtonText) && /*#__PURE__*/_react.default.createElement(_Button.default, {
    disabled: isNextButtonDisabled,
    id: "next-question",
    name: "name-question",
    onClick: function onClick() {
      contine_btns(currentStep);
      questionTracking(nextStep);
      nextQuestion();
    }
  }, currentStep === null || currentStep === void 0 ? void 0 : currentStep.nextButtonText);

  var disclaimerRenderer = function disclaimerRenderer(content) {
    switch (content.nodeType) {
      case 'text':
        return content.value;

      case 'paragraph':
        return /*#__PURE__*/_react.default.createElement("p", {
          key: content.content[0].value
        }, content.content.map(disclaimerRenderer));

      case 'hyperlink':
        return /*#__PURE__*/_react.default.createElement(_Link.default // eslint-disable-line jsx-a11y/anchor-is-valid
        , {
          newTab: true,
          key: content.data.uri,
          linkType: "external",
          path: content.data.uri
        }, disclaimerRenderer(content.content[0]));

      default:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
  };

  return /*#__PURE__*/_react.default.createElement(Track, null, /*#__PURE__*/_react.default.createElement(StyledWizard, null, /*#__PURE__*/_react.default.createElement(WizardBanner, null, category ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(BackGroupWidthDefiner, null, /*#__PURE__*/_react.default.createElement(BackGroup, {
    id: "wizard-back-button",
    tabIndex: 0,
    onClick: previousQuestion,
    onKeyDown: function onKeyDown(event) {
      handleKeyClick(event, 'link');
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Back Arrow",
    src: wizard === null || wizard === void 0 ? void 0 : (_wizard$backArrow = wizard.backArrow) === null || _wizard$backArrow === void 0 ? void 0 : _wizard$backArrow.url
  }), /*#__PURE__*/_react.default.createElement("span", null, wizard === null || wizard === void 0 ? void 0 : wizard.backText))), /*#__PURE__*/_react.default.createElement("div", null, category)) : /*#__PURE__*/_react.default.createElement("img", {
    alt: wizard === null || wizard === void 0 ? void 0 : (_wizard$logo = wizard.logo) === null || _wizard$logo === void 0 ? void 0 : _wizard$logo.title,
    src: wizard === null || wizard === void 0 ? void 0 : (_wizard$logo2 = wizard.logo) === null || _wizard$logo2 === void 0 ? void 0 : _wizard$logo2.url
  })), /*#__PURE__*/_react.default.createElement(ProgressBar, {
    "aria-label": "progressbar",
    "aria-valuemax": "100",
    "aria-valuemin": "0",
    "aria-valuenow": progressBarWidth,
    css: {
      paddingRight: started ? '5px' : '0px',
      width: "calc(".concat(progressBarValue, " - 5px)")
    },
    id: "progress-bar",
    role: "progressbar"
  }, progressBarValue), /*#__PURE__*/_react.default.createElement(WizardBody, {
    css: {
      animation: slideAnimation
    },
    key: clickIncrementer // used to trigger a rerender so the animations go on every nav click

  }, started && !showLoading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null, "Loading...")
  }, renderedQuestions[currentStepIndex]), /*#__PURE__*/_react.default.createElement(NavButtonContainer, null, shouldShowNextButton && currentStep.__typename.includes('Question') && nextButton, (currentStep === null || currentStep === void 0 ? void 0 : currentStep.skipText) && /*#__PURE__*/_react.default.createElement(SkipGroup, {
    id: "skip-link",
    tabIndex: 0,
    onClick: handleSkipClick,
    onKeyDown: function onKeyDown(event) {
      handleQuestionSkipClick(event, 'link');
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, currentStep === null || currentStep === void 0 ? void 0 : currentStep.skipText)), shouldShowNextButton && currentStep.__typename === 'SectionStep' && nextButton, (currentStep === null || currentStep === void 0 ? void 0 : currentStep.toResultsText) && /*#__PURE__*/_react.default.createElement(SkipGroup, {
    id: "skip-link",
    tabIndex: 0,
    onClick: function onClick() {
      handleSkipStyleClick(currentStep === null || currentStep === void 0 ? void 0 : currentStep.toResultsText, currentStep);
    },
    onKeyDown: function onKeyDown(event) {
      handleSectionSkipClick(event, 'link', currentStep === null || currentStep === void 0 ? void 0 : currentStep.toResultsText, currentStep);
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, currentStep === null || currentStep === void 0 ? void 0 : currentStep.toResultsText)), currentStepIndex === (wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti34 = wizard.stepsCollection) === null || _wizard$stepsCollecti34 === void 0 ? void 0 : (_wizard$stepsCollecti35 = _wizard$stepsCollecti34.items) === null || _wizard$stepsCollecti35 === void 0 ? void 0 : _wizard$stepsCollecti35.length) - 1 && /*#__PURE__*/_react.default.createElement(_Button.default, {
    disabled: isNextButtonDisabled,
    id: "submit-wizard",
    name: "submit-wizard",
    onClick: function onClick() {
      submitWizard(wizard === null || wizard === void 0 ? void 0 : wizard.submitButtonText, currentStep);
    }
  }, (wizard === null || wizard === void 0 ? void 0 : wizard.submitButtonText) || 'Submit')), (currentStep === null || currentStep === void 0 ? void 0 : currentStep.moreInformation) && /*#__PURE__*/_react.default.createElement(_MoreInformation.default, {
    category: currentStep.category,
    expandableText: (_currentStep$moreInfo = currentStep.moreInformation) === null || _currentStep$moreInfo === void 0 ? void 0 : (_currentStep$moreInfo2 = _currentStep$moreInfo.expandableText) === null || _currentStep$moreInfo2 === void 0 ? void 0 : _currentStep$moreInfo2.json,
    sectionNumber: currentStepIndex,
    text: currentStep.moreInformation.text.json
  }), (currentStepIndex === (wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti36 = wizard.stepsCollection) === null || _wizard$stepsCollecti36 === void 0 ? void 0 : (_wizard$stepsCollecti37 = _wizard$stepsCollecti36.items) === null || _wizard$stepsCollecti37 === void 0 ? void 0 : _wizard$stepsCollecti37.length) - 1 || (currentStep === null || currentStep === void 0 ? void 0 : currentStep.toResultsText) && currentStep.__typename == 'SectionStep') && Boolean(wizard === null || wizard === void 0 ? void 0 : wizard.submitDisclaimer) && /*#__PURE__*/_react.default.createElement(DisclaimerWrapper, {
    text: (_wizard$disclaimerTex = wizard === null || wizard === void 0 ? void 0 : wizard.disclaimerTextAlignment) !== null && _wizard$disclaimerTex !== void 0 ? _wizard$disclaimerTex : 'left'
  }, wizard === null || wizard === void 0 ? void 0 : (_wizard$submitDisclai = wizard.submitDisclaimer) === null || _wizard$submitDisclai === void 0 ? void 0 : (_wizard$submitDisclai2 = _wizard$submitDisclai.json) === null || _wizard$submitDisclai2 === void 0 ? void 0 : (_wizard$submitDisclai3 = _wizard$submitDisclai2.content) === null || _wizard$submitDisclai3 === void 0 ? void 0 : _wizard$submitDisclai3.map(disclaimerRenderer))), !started && !showLoading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(WizardTitleWrapper, null, /*#__PURE__*/_react.default.createElement(WizardTitle, null, wizard === null || wizard === void 0 ? void 0 : (_wizard$title2 = wizard.title) === null || _wizard$title2 === void 0 ? void 0 : _wizard$title2.replace('#', wizard === null || wizard === void 0 ? void 0 : (_wizard$stepsCollecti38 = wizard.stepsCollection) === null || _wizard$stepsCollecti38 === void 0 ? void 0 : _wizard$stepsCollecti38.items.filter(function (step) {
    return step.__typename !== 'SectionStep';
  }).length))), /*#__PURE__*/_react.default.createElement(_ImageOrLottie.default, Object.assign({}, wizard === null || wizard === void 0 ? void 0 : wizard.centerPicture, {
    css: {
      marginLeft: 'auto',
      marginRight: 'auto',
      width: 'fit-content'
    }
  })), /*#__PURE__*/_react.default.createElement(NavButtonContainer, null, (wizard === null || wizard === void 0 ? void 0 : wizard.beginButtonText) && /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    id: "start-wizard",
    name: "start-wizard",
    onClick: function onClick(event) {
      startWizard(wizard === null || wizard === void 0 ? void 0 : wizard.beginButtonText);
      questionTracking(currentStep);
      handleKeyClick(event, 'button');
    }
  }, wizard === null || wizard === void 0 ? void 0 : wizard.beginButtonText)), Boolean(wizard === null || wizard === void 0 ? void 0 : wizard.disclaimer) && /*#__PURE__*/_react.default.createElement(DisclaimerWrapper, {
    text: (_wizard$disclaimerTex2 = wizard === null || wizard === void 0 ? void 0 : wizard.disclaimerTextAlignment) !== null && _wizard$disclaimerTex2 !== void 0 ? _wizard$disclaimerTex2 : 'left'
  }, wizard === null || wizard === void 0 ? void 0 : (_wizard$disclaimer = wizard.disclaimer) === null || _wizard$disclaimer === void 0 ? void 0 : (_wizard$disclaimer$js = _wizard$disclaimer.json) === null || _wizard$disclaimer$js === void 0 ? void 0 : (_wizard$disclaimer$js2 = _wizard$disclaimer$js.content) === null || _wizard$disclaimer$js2 === void 0 ? void 0 : _wizard$disclaimer$js2.map(disclaimerRenderer))), /*#__PURE__*/_react.default.createElement(_Loading.default, {
    image: wizard === null || wizard === void 0 ? void 0 : wizard.loadingImage,
    isLoading: showLoading,
    text: wizard === null || wizard === void 0 ? void 0 : wizard.loadingText
  }))));
};

Wizard.defaultProps = {
  noFetch: false
};
var _default = Wizard;
exports.default = _default;